import React from "react";
import ProductCard from "./ProductCard";

export default function ProductList() {
  return (
    <section class="padding-y bg-light">
      <div className="container">
        <div className="row">
          <ProductCard></ProductCard>
          <ProductCard></ProductCard>
          <ProductCard></ProductCard>
          <ProductCard></ProductCard>
        </div>
      </div>
    </section>
  );
}
